<template>
  <div class="position-ab">
    <div
      :class="
        activeName == 4
          ? 'ccui-app-box-iframe-operate-container'
          : 'ccui-app-iframe-no-operate-container'
      "
    >
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <div
        :class="
          activeName == 4
            ? 'ccui-app-iframe-container-detail'
            : 'ccui-app-iframe-container-no-operate-detail'
        "
      >
        <div class="ccui-app-iframe-container-detail-body">
          <div
            style="top:80px;right:20px;position:absolute;z-index:2"
            class="sub-btnbox"
            v-if="isPilot == 1"
          >
            <el-button plain type="single-number" @click="AIBtn"
              >AI审查</el-button
            >
            <el-button plain type="single-number" @click="AIBtnRecord"
              >AI审查记录</el-button
            >
          </div>
          <el-tabs v-model="activeName" class="el-tabs__customize">
            <el-tab-pane label="开标一览表" name="1">
              <!--            <template v-if="activeName == 1">-->
              <template v-if="purchaseType != '50' && purchaseType != '53'">
                <div class="fr">
                  <el-button type="single-number" @click="exportPdf"
                    >导出Excel</el-button
                  >
                </div>
                <div class="clearfix"></div>
                <br />
              </template>
              <!--协议类展示数据-->
              <template v-if="purchaseType == '50' || purchaseType == '53'">
                <div class="textInfo" v-html="noticeInfoData.textInfo"></div>
                <el-tabs class="el-tabs__customize">
                  <el-tab-pane label="附件">
                    <el-table
                      :data="noticeInfoData.fileinfoBOS"
                      border
                      class="dic-sub-table-style01"
                    >
                      <el-table-column
                        type="index"
                        width="50"
                        label="序号"
                      ></el-table-column>
                      <el-table-column
                        property="fileName"
                        label="附件名称"
                        show-overflow-tooltip
                        width="180"
                      ></el-table-column>
                      <el-table-column
                        property="fileSize"
                        label="附件大小"
                        show-overflow-tooltip
                        width="180"
                      >
                        <template slot-scope="{ row }">
                          <span>{{ row.fileSize }}K</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        property="fileSumm"
                        label="附件说明"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        property="createTime"
                        label="上传时间"
                        show-overflow-tooltip
                        width="170"
                      ></el-table-column>
                      <el-table-column
                        label="操作"
                        show-overflow-tooltip
                        width="120"
                      >
                        <template slot-scope="{ row }">
                          <el-button type="text" @click="download(row)"
                            >下载</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              </template>
              <template v-else>
                <el-table
                  :data="bidOpenTableData"
                  border
                  class="dic-sub-table-style01"
                >
                  <el-table-column
                    v-for="(item, index) in bidOpenTableColumns"
                    :key="index"
                    :show-overflow-tooltip="true"
                    v-bind="item"
                  >
                    <template
                      v-if="
                        item.labelChild &&
                          item.labelChild.length > 0 &&
                          subPackageFlag
                      "
                    >
                      <el-table-column
                        v-for="(child, indexch) in item.labelChild"
                        :key="indexch"
                        align="right"
                      >
                        <template slot="header">
                          {{ child.label ? child.label : "-"
                          }}<span class="red" v-if="child.packStatusStr">{{
                            child.packStatusStr
                          }}</span>
                        </template>
                        <template slot-scope="scope">
                          <template v-if="child.type == 'link'">
                            <template v-if="scope.row[child.prop]">
                              <el-button
                                size="mini"
                                type="text"
                                @click="handleSupply(scope.row, 'kaibiaomoney')"
                                >{{
                                  scope.row[child.prop]
                                    ? new BigNumber(
                                        scope.row[child.prop]
                                      ).toFormat(2)
                                    : ""
                                }}</el-button
                              >
                            </template>
                            <template v-else>
                              <span>{{
                                scope.row[child.prop]
                                  ? new BigNumber(
                                      scope.row[child.prop]
                                    ).toFormat(2)
                                  : ""
                              }}</span>
                            </template>
                          </template>
                        </template>
                      </el-table-column>
                    </template>
                    <template slot-scope="scope">
                      <a
                        v-if="item.type == 'link'"
                        class="link-color"
                        href="javascript:void (0)"
                        @click="handleSupplier(scope.row, 'kaibiaosup')"
                        >{{ scope.row[item.prop] }}</a
                      >

                      <a
                        class="link-color"
                        href="javascript:void (1)"
                        v-else-if="
                          [
                            'priceAmount',
                            'priceAmountTaxExcluded',
                            'priceTaxAmount'
                          ].includes(item.prop)
                        "
                        @click="handleSupply(scope.row, 'kaibiaomoney')"
                      >
                        {{
                          scope.row.sscSupPackPriceBOS[0][item.prop] !== ""
                            ? new BigNumber(
                                scope.row.sscSupPackPriceBOS[0][item.prop]
                              ).toFormat(2)
                            : ""
                        }}</a
                      >

                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
            <!--协议类招标不展示-->
            <template
              v-if="purchaseType != '50' && purchaseType != '53' && reportShow"
            >
              <el-tab-pane label="供应商报价明细" name="2">
                <template v-if="packList.length > 0">
                  <el-tabs v-model="quoteDetailsActive" class="customeTab">
                    <el-tab-pane
                      v-for="(item, index) in packList"
                      :key="item.packId"
                      :label="
                        `${
                          Number(item.packStatus) !== 1
                            ? item.packName + '(已流标)'
                            : item.packName
                        }`
                      "
                      :name="index + ''"
                    >
                      <div v-loading="item.quoteDetailsListFrameLoading">
                        <iframe
                          class="no-print fine-report"
                          :ref="`quoteDetailsListFrame${index}`"
                          :id="`quoteDetailsListFrame${index}`"
                          :src="quoteDetailsUrlPackId"
                          frameborder="0"
                        ></iframe>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </template>
                <template v-else>
                  <div v-loading="quoteDetailsFrameLoading">
                    <iframe
                      class="no-print fine-report"
                      id="quoteDetailsFrame"
                      ref="quoteDetailsFrame"
                      :src="noSubPackagequoteDetailsUrl"
                      frameborder="0"
                    ></iframe>
                  </div>
                </template>
              </el-tab-pane>
            </template>
            <template v-if="reportShow">
              <el-tab-pane label="供应商投标信息预警" name="3">
                <!--            <p style="color: red">-->
                <!--              供应商投标信息预警功能，仅作为评标辅助参考使用。请招标人结合投标文件进行甄别。-->
                <!--            </p>-->
                <div v-loading="bidInfoWarningFrameLoading">
                  <iframe
                    class="no-print fine-report"
                    id="bidInfoWarningFrame"
                    ref="bidInfoWarningFrame"
                    :src="bidInfoWarningUrl"
                    frameborder="0"
                  ></iframe>
                </div>
              </el-tab-pane>
            </template>
            <el-tab-pane label="供应商投标文件" name="4">
              <div class="muchDownloadBox">
                <el-button
                  type="text"
                  icon="icon-ccui-print"
                  @click="muchDownload"
                  >批量下载</el-button
                >
              </div>

              <el-table
                :data="fileTableData"
                border
                @selection-change="selectChange"
                class="dic-sub-table-style01"
                style="margin-top: 30px;"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column
                  type="index"
                  width="55"
                  label="序号"
                ></el-table-column>
                <el-table-column
                  property="supName"
                  label="供应商名称"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="{ row }">
                    <el-button type="text" @click="handleSupply(row)"
                      >查看投标文件</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="供应商信用信息" name="5">
              <caigoufengxian :schemeId="schemeId"></caigoufengxian>
            </el-tab-pane>
            <el-tab-pane
              v-if="isShowRelation === '0'"
              label="供应商关联关系预警"
              name="6"
            >
              <div>
                <picketageRelationWarning
                  v-if="subPackageFlag"
                  ref="picketageRelationWarning"
                  sourceType="picketage"
                  :schemeId="schemeIdFlag"
                  :picketageData="picketageData"
                />
                <associationRelationWarning
                  v-else
                  ref="associationRelationWarning"
                  sourceType="picketage"
                  :schemeId="schemeIdFlag"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- <template v-if="activeName == 4">
        <div class="operate">
          <el-button type="text" icon="icon-ccui-print" @click="muchDownload"
            >批量下载</el-button
          >
        </div>
      </template> -->
      <el-dialog
        :visible.sync="supplierBidDetailsdialogVisible"
        title="供应商投标详细信息"
        width="1200px"
        v-if="supplierBidDetailsdialogVisible"
      >
        <supplierBidDetails
          :supPackQuoteId="formData.supPackQuoteId"
          :supQuoteId="formData.supQuoteId"
          :supCode="formData.supCode"
          :source="bidOpenSituation"
          :templateType="templateType"
        ></supplierBidDetails>
        <div slot="footer">
          <el-button
            size="mini"
            type="default-mini"
            @click="supplierBidDetailsdialogVisible = false"
            >取消</el-button
          >
          <el-button
            size="mini"
            type="primary-font-mini"
            @click="supplierBidDetailsdialogVisible = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <dialogSupplierDetail
        title="供应商详细信息"
        ref="dialogSupplierDetail"
        sourcePage="sourcingFlow"
        :supplierVisible.sync="supplierDetailDialog"
        :supplierDialogData="supplierDialogData"
        @cancel="closeDialogSupplierDetail"
      ></dialogSupplierDetail>
    </div>
    <AItable
      ref="AItable"
      :schemeId="schemeId"
      :bidPriceId="bidPriceId"
    ></AItable>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import associationRelationWarning from "@/app/sourcingFlow/components/associationRelationWarning.vue";
import picketageRelationWarning from "@/app/sourcingFlow/components/picketageRelationWarning.vue";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import AItable from "@/app/sourcingFlow/components/AITable";
import dialogSupplierDetail from "@/basa/components/common/dialogSupplierDetail";
import {
  qryCurrentRoundSupPriceApi,
  listPurchaseSchemePackageApi,
  qryBidPriceSupListApi,
  qryFileinfoListApi,
  qryBidPricePrepareApi,
  checkPilotCompany,
  qryNoticeDetailApi,
  getSchemePackList
  // qrySupBiddingFileInfoListApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";
import { addUrlPerFix, addUrlPerFix2, reportMarkPerFix } from "@/basa/utils";
import fineReport from "@/config/mixins/fineReport.js";
import caigoufengxian from "@/app/sourcingFlow/views/expertEvaluate/components/caigoufengxian";
import { commonTableWidth } from "@/setting/setting.js";

export default {
  name: "bidOpenSituation",
  components: {
    breadcrumbSourcing,
    caigoufengxian,
    supplierBidDetails,
    AItable,
    dialogSupplierDetail,
    associationRelationWarning,
    picketageRelationWarning
  },
  mixins: [fineReport],
  data() {
    return {
      templateType: "",
      BigNumber: BigNumber,
      isPilot: 2, //1试点
      bidOpenSituation: "bidOpenSituation",
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      breadcrumbData: {
        titname: "开标情况"
      },
      picketageData: [],
      isShowRelation: "1",
      filePath:
        "%25E4%25BE%259B%25E5%25BA%2594%25E5%2595%2586%25E6%258A%25A5%25E4%25BB%25B7%25E6%2598%258E%25E7%25BB%2586%25E7%25BB%259F%25E8%25AE%25A1.cpt",
      encodedFilePath:
        "%25E4%25BE%259B%25E5%25BA%2594%25E5%2595%2586%25E6%258A%25A5%25E4%25BB%25B7%25E6%2598%258E%25E7%25BB%2586%25E7%25BB%259F%25E8%25AE%25A1.cpt",
      purchaseType: sessionStorage.getItem("purchaseType"), // 招标方式
      dialogVisible: false,
      activeName: "1",
      bidOpenTableData: [], // 开标一览表
      supplierDetailDialog: false,
      supplierDialogData: {
        businessBillType: "",
        supCode: "",
        supinfoId: "",
        supName: ""
      },
      schemeIdFlag: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .schemeId,
      bidOpenPackHeaders: [], // 开标一览表表头
      supplierQuotationActiveName: "1",
      supplierQuotation: [], // 供应商报价
      biddInforWarnTableData: [], // 投标信息预警
      fileTableData: [], // 文件
      bidPriceId: "",
      bidOpenTableColumns: [
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "supName",
          label: "供应商",
          type: "link",
          width: commonTableWidth.supNameWidth
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          labelChild: [],
          align: "center"
        },
        {
          prop: "priceTime",
          label: "投标时间",
          width: commonTableWidth.dateTimeWidth
        },
        {
          prop: "contractName",
          label: "联系人",
          width: commonTableWidth.contractNameWidth
        },
        {
          prop: "mobile",
          label: "手机号",
          width: commonTableWidth.phoneWidth
        },
        {
          prop: "fax",
          label: "传真地址"
        },
        {
          prop: "email",
          label: "邮箱地址"
        }
      ],
      formData: {
        supQuoteId: 0, // 供应商报价ID
        supPackQuoteId: "",
        supCode: "" // 供应商编号
      },
      supplierBidDetailsdialogVisible: false,
      selectData: [], // 选择批量下载文件
      bidOpenExportHeaders: [], // 导出的开标一览表表头
      bidOpenExportColumns: [], // 导出的开标一览表columns
      bidOpenExportProps: [], // 导出的开标一览表Props
      packList: [],
      noticeInfoData: {
        textInfo: "",
        fileinfoBOS: []
      },
      picketageList: [],
      quoteDetailsActive: "0",
      bidInfoWarningFrameLoading: true,
      quoteDetailsFrameLoading: true,
      quoteDetailsListFrameLoading: true,
      reportShow: false, // 用于切换test、uat环境报表的地址
      quoteDetailsUrl: "", // 供应商报价明细分包报表地址
      quoteDetailsUrlPackId: "", // 供应商报价明细分包报表地址
      noSubPackagequoteDetailsUrl: "", // 供应商报价明细不分包报表地址
      bidInfoWarningUrl: "", // 供应商投标信息预警报表地址
      subPackageFlag: false, //true分包，false不分包
      isLeasingZone: false
    };
  },
  watch: {
    activeName(newVal, oldVal) {
      switch (newVal) {
        case "1":
          break;
        case "2":
          this.$nextTick(() => {
            this.quoteDetailsActive = "0";
            if (this.packList.length > 0) {
              // 分包
              this.quoteDetailsUrl = `${addUrlPerFix2(
                process.env.VUE_APP_FINEREPORT_SERVLET_URL
              )}?viewlet=${reportMarkPerFix(
                "smpc"
              )}%252FqryPackSupQuotationDetails.cpt&ref_t=design&ref_c=00fa13f8-6357-4a95-a75f-14daabc8611c&kj_schemeId=${
                JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
              }`;
              this.quoteDetailsUrlPackId = `${this.quoteDetailsUrl}&kj_packId=${this.packList[0].packId}`;
              this.setLoading("quoteDetailsListFrameLoading");
            } else {
              // 未分包
              this.noSubPackagequoteDetailsUrl = `${addUrlPerFix2(
                process.env.VUE_APP_FINEREPORT_SERVLET_URL
              )}?viewlet=${reportMarkPerFix(
                "smpc"
              )}%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&ref_c=00fa13f8-6357-4a95-a75f-14daabc8611c&kj_schemeId=${
                JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
              }`;
              this.setLoading("quoteDetailsFrameLoading");
            }
          });
          break;
        case "3":
          this.$nextTick(() => {
            if (this.reportShow) {
              this.bidInfoWarningUrl = `${addUrlPerFix2(
                process.env.VUE_APP_FINEREPORT_SERVLET_URL
              )}?viewlet=${reportMarkPerFix(
                "smpc"
              )}%252FqrySupBidWarning.cpt&ref_t=design&ref_c=00fa13f8-6357-4a95-a75f-14daabc8611c&kj_schemeId=${
                JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
              }`;
              this.setLoading("bidInfoWarningFrameLoading");
            }
          });
          break;
        case "4":
          break;
        case "5":
          break;
        case "6":
          this.$nextTick(() => {
            if (
              this.isShowRelation == "0" &&
              !this.subPackageFlag &&
              this.$refs.associationRelationWarning
            ) {
              this.$refs.associationRelationWarning.init();
            }
            if (
              this.isShowRelation == "0" &&
              this.subPackageFlag &&
              this.$refs.picketageRelationWarning
            ) {
              this.$refs.picketageRelationWarning.init();
            }
          });
          break;
        default:
          break;
      }
    },
    quoteDetailsActive(newVal, oldVal) {
      this.quoteDetailsUrlPackId = `${this.quoteDetailsUrl}&kj_packId=${this.packList[newVal].packId}`;
      this.setLoading("quoteDetailsListFrameLoading");
    }
  },
  updated() {
    if (this.bidInfoWarningFrameLoading) {
      this.$nextTick(() => {
        const { bidInfoWarningFrame } = this.$refs;
        const that = this;
        if (bidInfoWarningFrame.attachEvent) {
          bidInfoWarningFrame.attachEvent("onload", () => {
            that.setLoading("bidInfoWarningFrameLoading");
          });
        } else {
          bidInfoWarningFrame.onload = function() {
            that.setLoading("bidInfoWarningFrameLoading");
          };
        }
      });
    }
    if (this.quoteDetailsFrameLoading) {
      this.$nextTick(() => {
        const { quoteDetailsFrame } = this.$refs;
        const that = this;
        if (this.packList.length === 0) {
          if (quoteDetailsFrame.attachEvent) {
            quoteDetailsFrame.attachEvent("onload", () => {
              that.setLoading("quoteDetailsFrameLoading");
            });
          } else {
            quoteDetailsFrame.onload = function() {
              that.setLoading("quoteDetailsFrameLoading");
            };
          }
        }
      });
    }
    if (this.quoteDetailsListFrameLoading) {
      this.$nextTick(() => {
        const quoteDetailsListFrame = this.$refs[
          `quoteDetailsListFrame${this.quoteDetailsActive}`
        ];
        const that = this;
        if (this.packList.length > 0) {
          if (quoteDetailsListFrame.attachEvent) {
            quoteDetailsListFrame.attachEvent("onload", () => {
              that.setLoading("quoteDetailsListFrameLoading");
            });
          } else {
            quoteDetailsListFrame.onload = function() {
              that.setLoading("quoteDetailsListFrameLoading");
            };
          }
        }
      });
    }
  },
  created() {
    this.getSubPackageFlag();
    this.getData();
    checkPilotCompany({
      companyOrgId: sessionStorage.getItem("opUnitId"),
      type: 1
    }).then(res => {
      this.isPilot = res.data.data.data;
    });
    this.getRelation();
  },
  mounted() {
    this.isLeasingZone =
      JSON.parse(sessionStorage.getItem("expertSourceData")).baseAppId ==
        "107407" ||
      JSON.parse(sessionStorage.getItem("expertSourceData")).baseAppId ==
        "119934";
    if (this.isLeasingZone) {
      this.bidOpenTableColumns.splice(
        6,
        0,
        {
          prop: "priceAmountTaxExcluded",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）不含税",
          labelChild: [],
          align: "center"
        },
        {
          prop: "priceTaxAmount",
          label: "税额（" + sessionStorage.getItem("moneyTypeName") + "）",
          labelChild: [],
          align: "center"
        }
      );
    }
    // uat环境报表修改
    // let arr = location.hostname.split("-");
    // if (arr[0].includes("uat")) {
    //   // 供应商报价明细分包报表地址
    //   this.quoteDetailsUrl = `${addUrlPerFix2(
    //     process.env.VUE_APP_FINEREPORT_SERVLET_URL
    //   )}?viewlet=smpc-uat%252FqryPackSupQuotationDetails.cpt&ref_t=design&ref_c=df00f8df-b35e-4018-884b-922212baf947&kj_schemeId=${
    //     JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
    //   }`;
    //   // 供应商报价明细不分包报表地址
    //   this.noSubPackagequoteDetailsUrl = `${addUrlPerFix2(
    //     process.env.VUE_APP_FINEREPORT_SERVLET_URL
    //   )}?viewlet=smpc-uat%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&ref_c=df00f8df-b35e-4018-884b-922212baf947&kj_schemeId=${
    //     JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
    //   }`;
    //   // 供应商投标信息预警报表地址
    //   this.bidInfoWarningUrl = `${addUrlPerFix2(
    //     process.env.VUE_APP_FINEREPORT_SERVLET_URL
    //   )}?viewlet=smpc-uat%252FqrySupBidWarning.cpt&ref_t=design&ref_c=df00f8df-b35e-4018-884b-922212baf947&kj_schemeId=${
    //     JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
    //   }`;
    // }
    this.reportShow = true;
  },
  methods: {
    getSubPackageFlag() {
      listPurchaseSchemePackageApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    getRelation() {
      getSchemePackList({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        type: "1",
        percent: "25",
        phaseType: "8"
      }).then(res => {
        if (res.data.code == "0") {
          this.isShowRelation = res.data.data.isShow;
          console.log(this.subPackageFlag, "subPackageFlag");
          if (this.isShowRelation === "0") {
            this.picketageData = res.data.data.list;
          }
        }
      });
    },
    setLoading(key) {
      if (key == "quoteDetailsListFrameLoading") {
        this.$set(this.packList[Number(this.quoteDetailsActive)], key, false);
        this.quoteDetailsListFrameLoading = false;
      } else {
        this.$set(this, key, false);
      }
    },
    closeDialogSupplierDetail() {
      this.supplierDetailDialog = false;
    },
    handleSupplier(row) {
      this.supplierDetailDialog = true;
      this.supplierDialogData = {
        businessBillType: row.businessBillType,
        supCode: row.supCode,
        supinfoId: row.supinfoId,
        supName: row.supName
      };
    },
    AIBtn() {
      this.$refs.AItable.showDialogVisible = true;
    },
    AIBtnRecord() {
      this.$refs.AItable.getAiClearAddress(2);
    },

    getData() {
      if (this.purchaseType == "50" || this.purchaseType == "53") {
        // 协议类招标展示
        qryNoticeDetailApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          noticeStatus: "2",
          qryFileFlag: true,
          purStep: "7",
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            if (res.data.data) {
              this.noticeInfoData = res.data.data;
            } else {
              this.noticeInfoData = {
                textInfo: "",
                fileinfoBOS: []
              };
            }
          }
        });
      } else {
        qryCurrentRoundSupPriceApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          purStep: "6",
          isShowLoading: true
        }).then(res => {
          listPurchaseSchemePackageApi({
            pageNo: 1,
            pageSize: 100,
            // schemeId: "7110534015167361024"
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            isShowLoading: true
          }).then(restow => {
            // 是否分包 1分包0不分包
            // 是否分包 1分包0不分包
            this.subPackageFlag =
              restow.data.data.subPackageFlag == "1" ? true : false;
            console.log(restow.data, "33333");
            if (restow.data.code === "0") {
              restow.data.data.purchaseSchemePackageList.forEach(item => {
                item.quoteDetailsListFrameLoading = true;
              });
              this.packList = restow.data.data.purchaseSchemePackageList;
              const processedPackIds = {
                priceAmount: new Set(),
                priceAmountTaxExcluded: new Set(),
                priceTaxAmount: new Set()
              };
              let packBidTotalAmtlabelChild = [],
                packBidTotalAmtExcludedlabelChild = [],
                totalTaxAmountlabelChild = [];
              res.data.data.forEach((item, index) => {
                item.id = index + 1;
                item.sscSupPackPriceBOS.forEach((itemtow, indextow) => {
                  // restow.data.data.purchaseSchemePackageList.forEach(
                  //   (itemthre, indexthre) => {
                  //     if (itemthre.packId == itemtow.packId) {
                  //       itemtow.packStatusStr =
                  //         itemthre.packStatus !== 1
                  //           ? "（已流标）"
                  //           : "";
                  //       itemtow.packName = itemthre.packName;
                  //     }
                  //   }
                  // );
                  itemtow.packStatusStr =
                    Number(itemtow.packStatus) !== 1 ? "（已流标）" : "";
                  const {
                    packId,
                    packName,
                    bidFlag,
                    packStatusStr,
                    priceAmount,
                    priceAmountTaxExcluded,
                    priceTaxAmount
                  } = itemtow;
                  // 动态属性名
                  const priceProp = `priceAmount${packId}`;
                  const taxExcludedProp = `priceAmountTaxExcluded${packId}`;
                  const taxProp = `priceTaxAmount${packId}`;

                  // 设置item属性
                  item[priceProp] = priceAmount;
                  item[taxExcludedProp] = priceAmountTaxExcluded;
                  item[taxProp] = priceTaxAmount;

                  // 辅助函数：添加不重复的配置项
                  const addUniqueConfig = (
                    prop,
                    label,
                    bidFlag,
                    packStatusStr,
                    array,
                    processedSet
                  ) => {
                    if (!processedSet.has(packId)) {
                      array.push({
                        prop,
                        label,
                        bidFlag,
                        packStatusStr,
                        type: "link"
                      });
                      processedSet.add(packId);
                    }
                  };

                  // 添加配置项（自动去重）
                  addUniqueConfig(
                    priceProp,
                    packName,
                    bidFlag,
                    packStatusStr,
                    packBidTotalAmtlabelChild,
                    processedPackIds.priceAmount
                  );
                  if (this.isLeasingZone) {
                    addUniqueConfig(
                      taxExcludedProp,
                      packName,
                      bidFlag,
                      packStatusStr,
                      packBidTotalAmtExcludedlabelChild,
                      processedPackIds.priceAmountTaxExcluded
                    );
                    addUniqueConfig(
                      taxProp,
                      packName,
                      bidFlag,
                      packStatusStr,
                      totalTaxAmountlabelChild,
                      processedPackIds.priceTaxAmount
                    );
                  }
                });
              });
              if (this.subPackageFlag) {
                this.bidOpenTableColumns[5].labelChild = packBidTotalAmtlabelChild;
                if (this.isLeasingZone) {
                  this.bidOpenTableColumns[6].labelChild = packBidTotalAmtExcludedlabelChild;
                  this.bidOpenTableColumns[7].labelChild = totalTaxAmountlabelChild;
                }
              }
              console.log(this.bidOpenTableColumns);
              this.$set(this, "bidOpenTableData", res.data.data);
            }
            // this.getRelation();
          });
        });
      }
      qryBidPricePrepareApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: "6" // 寻源环节 开标环节：6谈判环节：11
      }).then(res => {
        this.templateType = res.data.data.priceTemplateType;
        this.bidPriceId = res.data.data.bidPriceId;
        // 文件
        qryBidPriceSupListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          bidPriceId: res.data.data.bidPriceId
        }).then(res => {
          this.fileTableData = res.data.data;
        });
      });
    },
    qryFileinfoList(fromItem) {
      return new Promise((resolve, reject) => {
        qryFileinfoListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: fromItem.supQuoteId,
          billType: "0603",
          uploadPhase: "0603"
        }).then(res => {
          if (res.data.data.length > 0) {
            res.data.data.forEach(item => {
              item.supQuoteId = fromItem.supQuoteId;
              item.supCode = fromItem.supCode;
              item.supName = fromItem.supName;
            });
          }
          resolve(res.data.data);
        });
      });
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    selectChange(select) {
      this.selectData = select;
    },
    // 批量下载
    muchDownload() {
      let supQuoteInfoList = [];
      if (this.selectData.length === 0) {
        this.fileTableData.forEach(item => {
          supQuoteInfoList.push({
            supQuoteId: item.supQuoteId,
            supName: item.supName
          });
        });
      } else {
        this.selectData.forEach(item => {
          supQuoteInfoList.push({
            supQuoteId: item.supQuoteId,
            supName: item.supName
          });
        });
      }
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      let params = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        schemeCode: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeCode,
        supQuoteInfoList: supQuoteInfoList
      };
      let href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/bidc/qrySupBiddingFileInfoList?reqBO=${JSON.stringify(
        params
      )}`;
      openUrl.href = encodeURI(href);
      console.log(openUrl.href);
      openUrl.setAttribute("download", "供应商投标文件.zip");
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    //投标金额跳转
    handleMoney(row) {},
    //供应商跳转
    handleSupply(row, type) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.supplierBidDetailsdialogVisible = true;
      if (type == "kaibiaomoney") {
        this.bidOpenSituation = "default";
      }
    },
    exportPdf() {
      switch (this.activeName) {
        case "1":
          // 开标一览表
          this.exportBidOpenTableDataPdf();
          break;
        case "2":
          break;
        case "3":
          break;
        default:
          this.exportBidOpenTableDataPdf();
          break;
      }
    },
    // 开标一览表导出开始
    exportBidOpenTableDataPdf() {
      this.exportData = [];
      if (this.bidOpenTableData.length > 5000) {
        this.$message({
          message: "暂不支持5000行以上大批量数据导出",
          type: "warning",

          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        this.bidOpenTableData.forEach((item, index) => {
          this.exportData.push(item);
        });
        if (this.ExcelJS) {
          this.exportBidOpenDefaultAll();
        } else {
          this.exportBidOpenCompatibleAll();
        }
      }
    },
    async exportBidOpenDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("开标一览表");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["开标一览表"]);
      ws1.addRow([this.content]);
      let headDataone = [],
        headData = [],
        columns = [],
        len = 0;
      console.log(this.bidOpenTableColumns);
      this.bidOpenTableColumns.forEach((item, index) => {
        if (item.labelChild && item.labelChild.length > 0) {
          item.labelChild.forEach((itemtow, indextow) => {
            let label = itemtow.label;
            if (itemtow.packStatusStr) {
              label = itemtow.label + "（已流标）";
            }
            headData.push(label);
            if (itemtow.prop.indexOf("priceAmountTaxExcluded") != -1) {
              headDataone.push(
                "投标金额（" +
                  sessionStorage.getItem("moneyTypeName") +
                  "） 不含税"
              );
            } else if (itemtow.prop.indexOf("priceAmount") != -1) {
              headDataone.push(
                "投标金额（" +
                  sessionStorage.getItem("moneyTypeName") +
                  "） 含税"
              );
              len++;
            } else {
              headDataone.push(
                "税额（" + sessionStorage.getItem("moneyTypeName") + "） "
              );
            }
            columns.push({
              key: itemtow.prop,
              width: 25
            });
          });
        } else {
          headDataone.push(item.label);
          headData.push(item.label);
          if (item.prop == "supName") {
            columns.push({
              key: item.prop,
              width: 55
            });
          } else if (item.prop == "id") {
            columns.push({
              key: item.prop,
              width: 5
            });
          } else {
            columns.push({
              key: item.prop,
              width: 25
            });
          }
        }
      });
      len += this.isLeasingZone ? 5 : 2;
      if (this.subPackageFlag) {
        ws1.addRow(headDataone);
      }
      ws1.addRow(headData);
      ws1.mergeCells("A1:J1");
      ws1.mergeCells("A2:J2");
      if (this.subPackageFlag) {
        if (this.isLeasingZone) {
          ws1.mergeCells(3, 1, 4, 1);
          ws1.mergeCells(3, 2, 4, 2); //第三行第二列合并到第四行第二列
          ws1.mergeCells(3, 3, 4, 3);
          ws1.mergeCells(3, 4, 4, 4);
          ws1.mergeCells(3, 5, 4, 5);
          ws1.mergeCells(3, 6, 3, len);
          ws1.mergeCells(3, len + 1, 3, len + 2); //合并报价金额不含税的列
          ws1.mergeCells(3, len + 3, 3, len + 4);
          ws1.mergeCells(3, len + 5, 4, len + 5);
          ws1.mergeCells(3, len + 6, 4, len + 6);
          ws1.mergeCells(3, len + 7, 4, len + 7);
          ws1.mergeCells(3, len + 8, 4, len + 8);
          ws1.mergeCells(3, len + 9, 4, len + 9);
        } else {
          ws1.mergeCells(3, 1, 4, 1);
          ws1.mergeCells(3, 2, 4, 2);
          ws1.mergeCells(3, 3, 3, len);
        }
      }
      ws1.columns = columns;
      this.bidOpenTableData.forEach((item, index) => {
        if (!this.subPackageFlag) item.priceAmount = item.priceAmount0;
        let obj = {};
        columns.forEach((itemtow, indextow) => {
          obj[itemtow.key] = item[itemtow.key];
          if (!this.subPackageFlag) obj.priceTaxAmount = item.priceAmount0;
        });
        ws1.addRow(obj);
      });
      ws1.getRow(3).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(3).fill = { color: { argb: "000000" } };
      if (this.subPackageFlag) {
        ws1.getRow(4).font = { bold: true, color: { argb: "000000" } };
        ws1.getRow(4).fill = { color: { argb: "000000" } };
      }

      ws1.getRow(2).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(2).fill = { color: { argb: "000000" } };
      ws1.getRow(1).font = { bold: true, color: { argb: "000000" } };
      ws1.getRow(1).fill = { color: { argb: "000000" } };
      ws1.getRow(1).alignment = {
        vertical: "middle",
        horizontal: "center",
        fixed: true
      };
      ws1.getRow(2).alignment = { vertical: "middle", horizontal: "left" };
      ws1.getRow(3).alignment = { vertical: "middle", horizontal: "center" };
      ws1.getRow(4).alignment = { vertical: "middle", horizontal: "left" };
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "开标一览表.xlsx");
    },
    exportBidOpenCompatibleAll() {
      const header = this.bidOpenExportHeaders;
      const filterVal = this.bidOpenExportProps;
      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "开标一览表"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/config/styles/finereport.scss";

/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
.wd6 {
  width: 60px;
}
.wd12 {
  width: 120px;
}
.wd20 {
  width: 200px;
}
.textInfo {
  padding: 1%;
  border: 1px solid #d1d1d1;
  width: inherit;
  max-height: 290px;
  min-height: 200px;
  overflow-y: scroll;
  overflow-wrap: break-word;
}
/deep/ .el-tabs__content {
  position: initial;
}
/deep/ .el-tabs__customize {
  position: relative;
}
.muchDownloadBox {
  position: absolute;
  top: 52px;
  right: 1px;
  z-index: 1003;
}
.red {
  color: red;
}
/deep/.el-dialog {
  overflow: hidden;
  margin-top: 0px;
  width: calc(100% - 240px) !important;
  left: 100px !important;
  top: 45px !important;
  .el-dialog__body {
    max-height: calc(100vh - 130px - 94px - 20px) !important;
    height: calc(100vh - 130px - 94px - 20px) !important;
  }
}
/deep/.el-table th > .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
.link-color {
  color: #0089ef !important;
}
</style>
